// @flow

import React from "react";
import { localize } from "redux-i18n";
import { reduxForm, Field, type FormProps } from "redux-form";
import { Form, FormGroup, Label, Button } from "@components";
import { DatePickerFormWrapper, TextField } from "@components/form";
import config from "@config";
type Props = $Exact<{
  handleSubmit: Function,
  onChange: Function,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
  ...PropsFromLocalize,
  onReset: () => void,
}>;

export class SelectEmployeeFilter extends React.Component<Props> {
  handleFormReset = () => {
    this.props.reset();
    this.props.onReset();
  };

  render() {
    return (
      <div className="w-100 d-flex mb-4">
        <Form className="w-100 d-flex justify-content-around" onSubmit={this.props.onSubmit}>
          <FormGroup className="p-0 pr-3 m-0">
            <Label for="lastName">{this.props.t("SURNAME")}</Label>
            <Field id="lastName" name="lastName" component={TextField} />
          </FormGroup>

          <FormGroup className="p-0 pr-3 m-0">
            <Label for="employeeRefPrimary">{this.props.t("EMPLOYEE_REF")}</Label>
            <Field id="employeeRefPrimary" name="employeeRefPrimary" component={TextField} />
          </FormGroup>

          <FormGroup className="p-0 pr-3 m-0">
            <Label for="dateOfBirth">{this.props.t("DATE_OF_BIRTH")}</Label>
            <Field
              name="dateOfBirth"
              component={DatePickerFormWrapper}
              customProps={{ dateFormat: config.dateFormatBE, id: "dateOfBirth" }}
            />
          </FormGroup>
          <Button className="mx-1 align-self-end" materialIcon="replay_circle_filled">
            {this.props.t("SUBMIT")}
          </Button>
          <Button color="secondary" className="mx-1 align-self-end" onClick={this.handleFormReset}>
            {this.props.t("RESET")}
          </Button>
        </Form>
      </div>
    );
  }
}

export default reduxForm({
  form: "select-employee-filter",
})(localize()(SelectEmployeeFilter));
